/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  CreateBoxExportRuleRequestBody,
  CreateBoxExportRuleResponse,
  GetBoxExportRuleResponse,
  GetBoxExportRulesResponse,
  UpdateBoxExportRuleRequestBody,
  UpdateBoxExportRuleResponse
} from '../model';

import getBoxExportRulesMutator from '../../../mutators/datastore-instance';
import createBoxExportRuleMutator from '../../../mutators/datastore-instance';
import getBoxExportRuleMutator from '../../../mutators/datastore-instance';
import updateBoxExportRuleMutator from '../../../mutators/datastore-instance';
import deleteBoxExportRuleMutator from '../../../mutators/datastore-instance';



  /**
 * 組織に登録された Box 書込ルールの一覧を更新日時の降順（updated_at DESC, id DESC）で取得します。
 * @summary Box 書込ルール一覧取得
 */
export const getBoxExportRules = (

 ) => {
      return getBoxExportRulesMutator<GetBoxExportRulesResponse>(
      {url: `/external-storages/box/export-rules`, method: 'GET'
    },
      );
    }
  /**
 * 組織に Box 書込ルールを 1 件作成します。
 * 書込ルール名が同一組織内で既に使われている場合は 400 を返します。
 * 1 つのワークフローを対象にできる書込ルールは 10 件までです。上限に達しているワークフローを
 * 対象に指定した場合は、他の書込ルールの状態との競合として 409 を返します。
 * @summary Box 書込ルール作成
 */
export const createBoxExportRule = (
    createBoxExportRuleRequestBody?: CreateBoxExportRuleRequestBody,
 ) => {
      return createBoxExportRuleMutator<CreateBoxExportRuleResponse>(
      {url: `/external-storages/box/export-rules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBoxExportRuleRequestBody
    },
      );
    }
  /**
 * 指定した Box 書込ルールを 1 件取得します。
 * この書込ルールを書込先として参照している取込ルールの一覧を含みます。
 * @summary Box 書込ルール取得
 */
export const getBoxExportRule = (
    id: number,
 ) => {
      return getBoxExportRuleMutator<GetBoxExportRuleResponse>(
      {url: `/external-storages/box/export-rules/${id}`, method: 'GET'
    },
      );
    }
  /**
 * 指定した Box 書込ルールを全項目置換で更新します。
 * `target_workflow_ids` と `target_folder_urls` も置換の対象です。
 * 書込が進行中でも更新できます。書込先フォルダと成果物種別の値は書込実行の生成時に読まれるため、
 * 更新後の値がその実行に適用されます。
 * 書込ルール名が同一組織内の別のルールで既に使われている場合は 400 を返します。
 * 1 つのワークフローを対象にできる書込ルールは 10 件までです。上限に達しているワークフローを
 * 対象に指定した場合は、他の書込ルールの状態との競合として 409 を返します。
 * @summary Box 書込ルール更新
 */
export const updateBoxExportRule = (
    id: number,
    updateBoxExportRuleRequestBody?: UpdateBoxExportRuleRequestBody,
 ) => {
      return updateBoxExportRuleMutator<UpdateBoxExportRuleResponse>(
      {url: `/external-storages/box/export-rules/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBoxExportRuleRequestBody
    },
      );
    }
  /**
 * 指定した Box 書込ルールを物理削除します。
 * 紐づく書込先フォルダと自動書き込みの対象ワークフローの関連、書込履歴も連鎖削除されます。
 * この書込ルールを書込先として参照していた取込ルールは、書込先の指定なしになります。
 * 書込が進行中の場合は 409 を返します。完了前のワークフロー実行にバインドされている場合と、
 * 終端していない書込実行がある場合が該当します。
 * @summary Box 書込ルール削除
 */
export const deleteBoxExportRule = (
    id: number,
 ) => {
      return deleteBoxExportRuleMutator<void>(
      {url: `/external-storages/box/export-rules/${id}`, method: 'DELETE'
    },
      );
    }
  export type GetBoxExportRulesResult = NonNullable<Awaited<ReturnType<typeof getBoxExportRules>>>
export type CreateBoxExportRuleResult = NonNullable<Awaited<ReturnType<typeof createBoxExportRule>>>
export type GetBoxExportRuleResult = NonNullable<Awaited<ReturnType<typeof getBoxExportRule>>>
export type UpdateBoxExportRuleResult = NonNullable<Awaited<ReturnType<typeof updateBoxExportRule>>>
export type DeleteBoxExportRuleResult = NonNullable<Awaited<ReturnType<typeof deleteBoxExportRule>>>
